import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/storagePlaces/form'
import { api, actionCreators } from 'store/modules/storagePlaces'

const metadata = {
  icon: 'archive',
  page: 'storagePlaces',
  dialogSize: dialogSizes.LG
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
